








































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {State, Getter, Action} from 'vuex-class';
import _ from 'lodash';
import ProductEngineUtils from '@/utils/ProductEngineUtils';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

import {SalesforceService} from '@/services/SalesforceService';
import Proposal from '@/models/proposal';
import Util from '@/utils/Util';
import EventBus from '@/common/EventBus';
import DefaultProductSelectionList from '@/components/products/productSelectionList/Default.vue';
import WorkflowService from '@/services/WorkflowService';

const CATALOGUE_LAYOUT = 'ProductSelectionList';

@Component({
  name: 'OtherProducts',
  components: {
    DefaultProductSelectionList
  },
})
export default class OtherProducts extends Vue {
  @Prop() private product: any;
  @Prop({ default: 'confirmation' }) private translationPrefix!: string;
  @State private app: any;
  @State private cms: any;
  @State private proposal!: Proposal;
  @Getter('cms/getProductContentByProduct') private getProductContentByProduct: any;
  @Action('app/setPardotAvailability') private setPardotAvailability: any;
  @Action('cms/loadOtherProducts') private loadOtherProductsContent: any;
  @Getter('quotation/getFactValueByFactID') private getFactValueByFactID!: (factID: string) => string;

  private products: any = [];
  private selected: any = [];
  private contactName: string = '';
  private contactEmail: string = '';
  private contactPhone: string = '';

  get layoutType() {
    return this.cms.layout.catalogueType + CATALOGUE_LAYOUT;
  }

  get isFromLandingCatalog() {
    return this.translationPrefix === 'landing';
  }

  get isValidContactInfo() {
    if (!this.isFromLandingCatalog) {
      return true;
    }
    return this.contactName && this.contactEmail && this.contactPhone &&
           !this.hasNameError && !this.hasEmailError && !this.hasPhoneError;
  }

  get hasNameError() {
    if (!this.isFromLandingCatalog) {
      return false;
    }
    return this.contactName.length > 0 && this.contactName.trim().length < 2;
  }

  get hasEmailError() {
    if (!this.isFromLandingCatalog) {
      return false;
    }
    return this.contactEmail.length > 0 &&
           !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.contactEmail.trim());
  }

  get hasPhoneError() {
    if (!this.isFromLandingCatalog) {
      return false;
    }
    if (this.contactPhone.length === 0) {
      return false;
    }
    try {
      const phoneNumber = parsePhoneNumberFromString(this.contactPhone.trim());
      return !phoneNumber || !phoneNumber.isPossible();
    } catch (e) {
      return true;
    }
  }

  get isButtonDisabled() {
    if (this.isFromLandingCatalog) {
      return this.selected.length === 0 || !this.isValidContactInfo;
    } else {
      return this.selected.length === 0;
    }
  }

  private toggleSelection(selected: any) {
    this.selected = selected;
  }

  private checkSelected(product: any) {
    return !!_.find(this.selected, {code: product.code});
  }

  private callAdvisor() {

    EventBus.$emit('open-loading-dialog');
    this.sendTask().then(() => {
      setTimeout(() => {
        this.$dialog.open({
          icon: _.get(this.cms, 'theme.successIcon'),
          text: this.$t(`${this.translationPrefix}.otherProduct.confirmDialogMessage`),
          buttons: [{ text: this.$t('button.closeDialog') }]
        });
        EventBus.$emit('close-loading-dialog');
      }, 2000);
      this.selected = [];
      if (this.isFromLandingCatalog) {
        this.contactName = '';
        this.contactEmail = '';
        this.contactPhone = '';
      }
    });
  }

  private async sendTask() {
    const productsInSTring = this.selected.map((product: any) => product.title).join(', ');
    const contactInfo = this.proposal.contactInfo;

    const name = this.isFromLandingCatalog && this.contactName.trim()
      ? this.contactName.trim()
      : `${contactInfo?.givenName} ${contactInfo?.familyName}`;

    const phone = this.isFromLandingCatalog && this.contactPhone.trim()
      ? this.contactPhone.trim()
      : contactInfo.phone;

    let context: any = {
      title: 'A user is interested in an offline product',
      type: 'Coverhub request',
      source: window.location.href,
      name,
      phone,
      email: contactInfo?.email || this.contactEmail?.trim(),
      message: `Product: ${productsInSTring}`,
    };

    const workflowName = this.proposal?.proposalId ? 'create-offline-product-interest-form' : 'create-contact-form-task';

    if (this.proposal?.proposalId) {
      context = {
        ...context,
        proposalId: this.proposal?.proposalId
      };
    }
    return WorkflowService.runWorkflowSync(workflowName, context, ['task']);
  }

  private created() {
    this.loadProducts();
  }

  private async loadProducts() {
    await this.loadOtherProductsContent();

    const otherProducts = _.filter(this.cms.otherProducts, (prod) => {
      return !prod.fields.hide;
    });
    this.products = _.sortBy(
        _.map(otherProducts, (product: any) =>
            this.getProductContentByProduct(product),
        ),
        ['index'],
    );
  }

  private onInfoBtnClick(product: any) {
    this.$emit('onInfoBtnClick', product);
  }
}
